export const NAME = 'billing';
export const BILLING_EMAIL_FORM_NAME = 'billingEmailForm';
export const BILLING_COUPON_FORM_NAME = 'billingCouponForm';
export const TAX_ID_FORM_NAME = 'taxIdForm';
export const METERED_LINE_ITEMS = ['bandwidth', 'apiCdnBandwidth'];
export const BILLING_SECTION_GAP = 3;

export const PAYMENT_SOURCE = 'payment';
export const COUPON_SOURCE = 'coupon';
export const EMAIL_SOURCE = 'email';
export const PLAN_SOURCE = 'plan';
export const TAX_ID_SOURCE = 'taxId';
export const ADDRESS_SOURCE = 'address';
export type SOURCE =
  | typeof PAYMENT_SOURCE
  | typeof COUPON_SOURCE
  | typeof EMAIL_SOURCE
  | typeof PLAN_SOURCE
  | typeof TAX_ID_SOURCE
  | typeof ADDRESS_SOURCE;

// From https://stripe.com/docs/billing/customer/tax-ids?dashboard-or-api=api
export const taxIdOptions: Record<string, string> = {
  ad_nr: 'Andorran NRT',
  ar_cuit: 'Argentinian tax ID number',
  au_abn: 'Australian Business Number (AU ABN)',
  au_arn: 'Australian Taxation Office Reference Number',
  bo_tin: 'Bolivian tax ID',
  br_cnpj: 'Brazilian CNPJ number',
  br_cpf: 'Brazilian CPF number',
  bg_uic: 'Bulgaria Unified Identification Code',
  ca_bn: 'Canadian BN',
  ca_gst_hst: 'Canadian GST/HST number',
  ca_pst_bc: 'Canadian PST number (British Columbia)',
  ca_pst_mb: 'Canadian PST number (Manitoba)',
  ca_pst_sk: 'Canadian PST number (Saskatchewan)',
  ca_qst: 'Canadian QST number (Québec)',
  cl_tin: 'Chilean TIN',
  cn_tin: 'Chinese tax ID',
  co_nit: 'Colombian NIT number',
  cr_tin: 'Costa Rican tax ID',
  do_rcn: 'Dominican RCN number',
  ec_ruc: 'Ecuadorian RUC number',
  eg_tin: 'Egyptian Tax Identification Number',
  sv_nit: 'El Salvadorian NIT number',
  eu_oss_vat: 'European One Stop Shop VAT number for non-Union scheme',
  eu_vat: 'European VAT number',
  ge_vat: 'Georgian VAT',
  hk_br: 'Hong Kong BR number',
  hu_tin: 'Hungary tax number (adószám)',
  is_vat: 'Icelandic VAT',
  in_gst: 'Indian GST number',
  il_vat: 'Israel VAT',
  jp_cn: 'Japanese Corporate Number',
  jp_rn: "Japanese Registered Foreign Businesses' Registration Number",
  jp_trn: 'Japanese Tax Registration Number',
  ke_pin: 'Kenya Revenue Authority Personal Identification Number',
  li_uid: 'Liechtensteinian UID number',
  my_frp: 'Malaysian FRP number',
  my_itn: 'Malaysian ITN',
  my_sst: 'Malaysian SST number',
  mx_rfc: 'Mexican RFC number',
  nz_gst: 'New Zealand GST number',
  no_vat: 'Norwegian VAT number',
  pe_ruc: 'Peruvian RUC number',
  ph_tin: 'Philippines Tax Identification Number',
  ru_inn: 'Russian INN',
  ru_kpp: 'Russian KPP',
  sa_vat: 'Saudi Arabia VAT',
  rs_pib: 'Serbian PIB number',
  sg_gst: 'Singaporean GST',
  sg_uen: 'Singaporean UEN',
  si_tin: 'Slovenia tax number',
  za_vat: 'South African VAT number',
  kr_brn: 'Korean BRN',
  es_cif: 'Spanish NIF number',
  ch_vat: 'Switzerland VAT number',
  tw_vat: 'Taiwanese VAT',
  th_vat: 'Thai VAT',
  tr_tin: 'Turkish Tax Identification Number',
  ua_vat: 'Ukrainian VAT',
  ae_trn: 'United Arab Emirates TRN',
  gb_vat: 'United Kingdom VAT number',
  us_ein: 'United States EIN',
  uy_ruc: 'Uruguayan RUC number',
  ve_rif: 'Venezuelan RIF number',
  vn_tin: 'Vietnamese tax ID number'
};
